import { render } from "./TemplateBlockVisualEditor.vue?vue&type=template&id=680a6adc&scoped=true"
import script from "./TemplateBlockVisualEditor.vue?vue&type=script&lang=js"
export * from "./TemplateBlockVisualEditor.vue?vue&type=script&lang=js"

import "./TemplateBlockVisualEditor.vue?vue&type=style&index=0&id=680a6adc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680a6adc"]])

export default __exports__